import * as types from './transcripts.types';

export const transcriptPageSelectors: types.ISessionTranscriptsPageSelectors = {
  selectSessionTranscriptsBySessionId: (state, sessionId) =>
    state.page.sessionTranscripts.sessionTranscripts[sessionId],
};
